// Types d'actions
export const SET_LOADING = 'SET_LOADING';
export const SHOW_NOTIFICATION = 'SHOW_NOTIFICATION';
export const HIDE_NOTIFICATION = 'HIDE_NOTIFICATION';
export const CLEAR_NOTIFICATIONS = 'CLEAR_NOTIFICATIONS';

const MAX_TOASTS = 3;

// État initial
const initialState = {
  loading: false,
  notifications: []
};

// Reducer
const uiReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
      
    case SHOW_NOTIFICATION: {
      const next = [...state.notifications, {
        id: action.payload.id,
        type: action.payload.type,
        title: action.payload.title,
        message: action.payload.message,
        duration: action.payload.duration
      }];
      return {
        ...state,
        notifications: next.length > MAX_TOASTS ? next.slice(next.length - MAX_TOASTS) : next
      };
    }
      
    case HIDE_NOTIFICATION:
      return {
        ...state,
        notifications: state.notifications.filter(
          notification => notification.id !== action.payload
        )
      };
      
    case CLEAR_NOTIFICATIONS:
      return {
        ...state,
        notifications: []
      };
      
    default:
      return state;
  }
};

// Actions
export const setLoading = (isLoading) => ({
  type: SET_LOADING,
  payload: isLoading
});

export const showNotification = (notification) => {
  const id = Date.now().toString();
  
  return {
    type: SHOW_NOTIFICATION,
    payload: {
      id,
      type: notification.type || 'info',
      title: notification.title || '',
      message: notification.message || '',
      duration: notification.duration || 3000
    }
  };
};

export const hideNotification = (id) => ({
  type: HIDE_NOTIFICATION,
  payload: id
});

export const clearNotifications = () => ({
  type: CLEAR_NOTIFICATIONS
});

export default uiReducer;